import React, { useContext, useEffect, useState } from "react";
import { Box, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Button, Checkbox, FormControlLabel, useTheme, useMediaQuery, } from "@mui/material";
import Draggable from "react-draggable";
import { ThemeContext } from "../../context/ThemeContext";
import { CloseSharp } from "@mui/icons-material";
import { getCookies } from "../../services/Cookies";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setIsUserSigned } from "../../store/Slices/watchList";

const DraggableBox = React.forwardRef(({ children, ...props }, ref) => (
    <Draggable handle=".header">
        <div ref={ref} {...props}>{children}</div>
    </Draggable>
));

const OneClickTrading = ({ isOpen, onClose, onAccept }) => {
    const { darkMode } = useContext(ThemeContext);
    const [isAgreed, setIsAgreed] = useState(false);
    const clientId = getCookies("clientId");
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const handleAgreeChange = (event) => {
        setIsAgreed(event.target.checked);
    };

    const handleAccept = () => {
        if (isAgreed) {
            const agreementKey = `oneClickTradingAgreement_${clientId}`;
            localStorage.setItem(agreementKey, JSON.stringify({ agreed: true }));
            onAccept();
            dispatch(setIsUserSigned(true))
            onClose();
        }
    };
    useEffect(() => {
        const agreementKey = `oneClickTradingAgreement_${clientId}`;
        const savedAgreement = localStorage.getItem(agreementKey);
        if (savedAgreement) {
            const { agreed } = JSON.parse(savedAgreement);
            setIsAgreed(agreed);

        }
    }, [clientId]);
    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm" PaperComponent={(props) => (
            <DraggableBox {...props} style={{ position: "absolute", top: isMobile ? "5%" :"1%", left: isMobile ? "0%" : "30%", transform: "translate(-50%, -50%)" }} />)}
            sx={{ "& .MuiDialog-paper": { backgroundColor: darkMode ? "#0f1720" : "var(--white)", color: darkMode ? "#d1d1d1" : "#333", boxShadow: darkMode ? "0px 16px 46px 8px rgba(0, 0, 0, 0.12)" : "0 10px 20px rgba(169, 169, 169, 0.3), 4px 4px 10px rgba(169, 169, 169, 0.2), -4px 4px 5px rgba(169, 169, 169, 0.1)", }, }}>
            <DialogTitle sx={{ padding: '12px', cursor: "move", display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: darkMode ? "#1976d2" : "#1976d2", color: "white", }} className="header">
                <Typography variant="body2">{t('oneClickDisclaimer')}</Typography>
                <CloseSharp onClick={onClose} sx={{ cursor: "pointer", fontSize: '18px' }} />
            </DialogTitle>

            <DialogContent sx={{ padding: 2, overFlowY: 'scroll', height: 350 }}>
                <Typography variant="caption">
                    {t("line1")}
                    {t("line2")}<br /><br />
                    {t("line3")}<br /><br />
                    {t("line4")}

                    <ul style={{ marginTop: 0 }}>
                        <li>{t("list.item1")}</li>
                        <li>{t("list.item2")}</li>
                        <li>{t("list.item3")}</li>
                    </ul>
                    <br />
                    {t("line5")}
                    {t("line6")}
                    {t("line7")}<br /><br />
                    {t("line8")}
                    {t("line9")} {process.env.REACT_APP_COMPANY_NAME} {t("line10")}



                </Typography>
            </DialogContent>

            <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box display='flex' justifyContent="flex-start" alignItems="center">
                    <FormControlLabel
                        control={<Checkbox checked={isAgreed} onChange={handleAgreeChange} />}
                        label={t('oneClickTerm')} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.85rem" }, color: darkMode ? "var(--lightText)" : 'black' }}
                    />
                </Box>
                <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
                    <Button onClick={onClose} variant="outlined" color="secondary">{t("cancel")}</Button>
                    <Button onClick={handleAccept} variant="contained" color="secondary" disabled={!isAgreed}>{t("accept")}</Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default OneClickTrading;
